import { render, staticRenderFns } from "./TwoColForm.vue?vue&type=template&id=1d5c3bdc&"
import script from "./TwoColForm.vue?vue&type=script&lang=js&"
export * from "./TwoColForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports